// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import * as filters from './filters'

Vue.use(ElementUI)

import App from './App.vue'

import TopBar from './components/TopBar.vue'
import TinyTopBar from './components/TopBarTiny.vue'
import OldFooter from './components/OldFooter.vue'
import Product from './components/Product.vue'
import TableHeader from './components/TableHeader.vue'
import SmsLogin from './components/SmsLogin.vue'
import Cart from './components/Cart.vue'
import Order from './components/Order.vue'
import HotProducts from './components/HotProducts.vue'
import Header from './components/Header.vue'
import News from './components/News.vue'
import Loading from './components/Loading.vue'
import SideBar from './components/SideBar.vue'
import Brand from './components/Brand.vue'
import WxPay from './components/WxPay.vue'
import CompanyDialog from './components/CompanyDialog.vue'
import CompanySelection from './components/CompanySelection.vue'

import OrderDetails from './components/OrderDetails.vue'
import Footer from './components/Footer.vue'

import ReviewList from './components/product/ReviewList.vue'
import RelatedProducts from './components/product/RelatedProducts.vue'
import Search from './components/Search.vue'


import ArticleHeader from './components/article/Header.vue'
import ArticleHotList from './components/article/HotArticleList.vue'
import ArticleQrCode from './components/article/QrCode.vue'
import AreaPicker from './components/AreaPicker.vue'
import ArticleList from './components/ArticleList.vue'

import SlideTabContainer from './components/SlideTabContainer.vue'
import ServiceDetail from './components/ServiceDetail.vue'

Vue.component('lh-top-bar', TopBar)
Vue.component('lh-product', Product)
Vue.component('lh-table-header', TableHeader)
Vue.component('lh-sms-login', SmsLogin)
Vue.component('lh-cart', Cart)
Vue.component('lh-order', Order)
Vue.component('lh-hot-products', HotProducts)
Vue.component('lh-header', Header)
Vue.component('lh-footer', OldFooter)
Vue.component('lh-news', News)
Vue.component('lh-loading', Loading)
Vue.component('lh-side-bar', SideBar)
Vue.component('lh-brand', Brand)
Vue.component('lh-wxpay', WxPay)
Vue.component('company-dialog', CompanyDialog)
Vue.component('company-selection', CompanySelection)

Vue.component('zj-footer', Footer)
Vue.component('zj-order-details', OrderDetails)
Vue.component('zj-search', Search)
Vue.component('zj-review-list', ReviewList)
Vue.component('zj-related-products', RelatedProducts)
Vue.component('zj-area-picker', AreaPicker)
Vue.component('zj-tiny-top-bar', TinyTopBar)
Vue.component('zj-service-detail', ServiceDetail)

Vue.component('slide-tab-container', SlideTabContainer)

Vue.component('article-header', ArticleHeader)
Vue.component('article-hot-list', ArticleHotList)
Vue.component('article-qr-code', ArticleQrCode)
Vue.component('article-list', ArticleList)

Vue.filter('cdn-filter', filters.cdnPrefix)
Vue.filter('subTotalPriceFilter', filters.totalPrice)
Vue.filter('totalPriceFilter', filters.totalPrice2)
Vue.filter('date-filter', filters.dateFormat)
Vue.filter('dateFromNowFilter', filters.dateFromNow)
Vue.filter('region-filter', filters.regionFormat)
Vue.filter('zero-price-filter', filters.zeroPriceTip)

import _ from 'lodash'
import moment from 'moment'
import axios from 'axios'


window._ = _


window.__DEV__ = process.env.NODE_ENV === 'development'
// window.__DEV__ = true

moment.locale('zh-cn')

Vue.config.devtools = true


axios.defaults.baseURL = process.env.API
axios.defaults.headers.common['Authorization'] = localStorage.getItem('token') || '1'
// axios.defaults.headers.common['Authorization'] = Vue.$store.getters.getToken || '1'

Vue.prototype.$http = axios

window.setCookie = (key, value, expiredays) => {
  let exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = key + "=" + decodeURI(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString())
}
// 获取cookie、
function getCookie(name) {
  let arr
  let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return (arr[2])
  } else {
    return null
  }
}
window.getCookie = getCookie;
// 删除cookie
window.delCookie = (name) => {
  let exp = new Date()
  exp.setTime(0)
  let cval = getCookie(name)
  if (cval !== null) {
    document.cookie = `${name}=;expires=${exp.toGMTString()}path=/;domain=${process.env.COOKIE_DOMAIN}`
  }
}
store.dispatch('init')
store.dispatch('getUserInfo', true)

Vue.mixin({
  methods: {
    tipError(error) {
      this.error = error
      this.$message({
        type: 'error',
        message: (error && error.message) || 'error'
      })
    },
    tipSuccess(msg) {
      this.$message({
        type: 'success',
        message: msg || 'success'
      })
    },
    changeHeader(store, route, data) {
      if (document) {
        console.log('========begin========')
        let classificationInfo = store.state.product.CATEGORY_CODE

        let path = route.path
        let meta = route.meta
        if (meta) {
          document.title = meta.title || '企业湾-注册财税一条龙服务'
        }

        console.log(path)

        let description = document.querySelector("meta[name=description]")
        let keywords = document.querySelector("meta[name=keywords]")

        description.setAttribute('content', '企业湾隶属于上海知加信息科技有限公司，是国内领先的专注于中小企业领域一站式综合服务提供商，其税务筹划、工商服务、资质办理、财税服务、法律服务、人事服务、IT&设计等服务深受客户的赞誉。​公司核心团队主要由行业资深专家以及互联网创业精英组成。')
        if (path === '/home' || path === '/') {
          document.title = '企业湾|注册公司-代理记账-商标注册-税务筹划'
          keywords.setAttribute('content', '苏州注册公司,合理避税,商标注册费用,上海代理记账,国际商标注册,注册公司流程,代理记账,商标注册')
        }
        // 产品详情页
        else if (/^\/product-detail\/\S*$/.test(path)) {
          let product = data
          // if (product) {
          //   document.title = '企业湾-' + product.name
          //   keywords.setAttribute('content', `企业湾,${classificationInfo[product.classificationCode]},${product.classificationName},${product.name}`)
          //   description.setAttribute('content', product.summary)
          // }
          let cateCode = product.serialId.substring(4, 6)
          let _title = ''
          let _keywords = ''
          switch (cateCode) {
            case 'IT':
              _title = 'IT&设计_苏州注册公司_注册公司流程-企业湾'
              _keywords = '上海代理记账,注册公司'
              break
            case 'IC':
              _title = '工商服务_南京注册公司_上海注册公司-企业湾'
              _keywords = '商标注册费用,苏州注册公司'
              break
            case 'PS':
              _title = '创业套餐_注册公司费用_深圳注册公司-企业湾'
              _keywords = '国际商标注册,注册公司流程'
              break
            case 'FC':
              _title = '财税服务_合理避税_代理记账-企业湾'
              _keywords = '深圳注册公司,注册公司费用'
              break
            case 'QF':
              _title = '资质办理_商标注册流程_国际商标注册-企业湾'
              _keywords = '注册公司费用,商标转让'
              break
            case 'TP':
              _title = '税务筹划_上海代理记账_商标注册-企业湾'
              _keywords = '合理避税,代理记账'
              break
            case 'LD':
              _title = '法律服务_商标注册费用_商标转让-企业湾'
              _keywords = '商标注册流程,商标注册'
              break
            case 'HR':
              _title = '人事服务_注册公司费用_注册公司-企业湾'
              _keywords = '代理记账,商标注册'
              break
            default:
              _title = '深圳注册公司,注册公司费用'
              _keywords = '代理记账, 商标注册'
          }
          document.title = _title
          keywords.setAttribute('content', _keywords)
          description.setAttribute('content', product.summary)
        }
        // 文章首页 列表页
        else if (/^\/product-list/.test(path)) {
          let classificationCode = route.params.cate1
          let products = data
          // 地区变更时 产品列表页路由未变化，暂时取第一个产品的分类
          let classificationName = products[0] ? products[0].classificationName : classificationInfo[classificationCode]
          let productNameStr = products.reduce((s, p) => s + p.name + '、', '')

          document.title = `${classificationName}-企业湾`
          keywords.setAttribute('content', productNameStr)
          description.setAttribute('content', productNameStr)
        }
        // 文章首页 列表页
        else if (path === '/ArticleHome' || /^\/articles\/list/.test(path)) {
          keywords.setAttribute('content', `企业湾，文章中心，创业咨询，财务干货，人事干货，法律干货，工商干货`)
          description.setAttribute('content', '企业湾，文章中心，创业咨询，财务干货，人事干货，法律干货，工商干货')
        }
        // 文章详情
        else if (/^\/articles\/\d*$/.test(path)) {
          let article = data
          document.title = `${article.title}-企业湾`
          keywords.setAttribute('content', article.tag_list)
          description.setAttribute('content', article.summary)
        }
        else {
          document.title = '企业湾-注册财税一条龙服务'
          keywords.setAttribute('content', '企业湾,注册公司,代理记账,商标注册,个人社保,企业社保,创业法律服务,网站建设')
        }
        console.log('=============finish==================')
      }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  template: '<App/>',
  components: {App}
})

export {
  store
}



// WEBPACK FOOTER //
// ./src/main.js